import { isValidVersion } from './compareVersions';

export type AppUpdateMode = 'optional' | 'required';
export type AppUpdatePlatform = 'ios' | 'android';

export type AppUpdateFlag = {
	mode: AppUpdateMode;
	ios?: string;
	android?: string;
};

const isMode = (value: unknown): value is AppUpdateMode =>
	value === 'optional' || value === 'required';

/** Anything that is not a well-formed flag value becomes `null`; an invalid threshold is dropped. */
export const parseAppUpdateFlag = (raw: unknown): AppUpdateFlag | null => {
	if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) return null;
	const { mode, ios, android } = raw as Record<string, unknown>;
	if (!isMode(mode)) return null;
	return {
		mode,
		...(isValidVersion(ios) ? { ios } : {}),
		...(isValidVersion(android) ? { android } : {}),
	};
};
